module.exports = __webpack_public_path__ + "static/img/gift.bb47cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/gift.png
// module id = ajuN
// module chunks = 1